// Generated by ts-to-zod
import { z } from 'zod';

export const createDedicatedEnginePayloadSchema = z.object({
  name: z.string(),
});
